import { GET_AWB_PART_STATUSES } from './actionTypes';

import awbRemote from '../../api/awbRemote';

import ApiResponse from '../../models/ApiResponse';
import ResponseError from '../../models/ResponseError';
import { AwbPartStatuses } from '../../models/AwbPart';

import { receiveError } from './notificationAction';

function getAwbPartStatusesSuccess(partStatuses: AwbPartStatuses) {

  return {
    type: GET_AWB_PART_STATUSES,
    payload: partStatuses
  };
}

function getAwbPartStatuses() {

  return (dispatch: any) => {

    awbRemote.getAwbPartStatuses().then((res: ApiResponse<AwbPartStatuses>) => {

      const partStatuses: AwbPartStatuses | undefined = res.result;
      const error: ResponseError | undefined = res.error;

      if (partStatuses) {
        dispatch(getAwbPartStatusesSuccess(partStatuses));
      } 
  
      if (error) {
        dispatch(receiveError(error));
      }
    });
  };
}

export {
  getAwbPartStatuses
};